<template>
  <div class="page-rule">
    <fixed-header title="会员说明" :black="true" :left="true" />
    <div class="rule-wrap" v-html="pageData"></div>
  </div>
</template>

<script>
import { getMemberExpConfig } from "../../../api";
import FixedHeader from "../../../components/FixedHeader";
export default {
  name: "memberRule",
  components: {
    FixedHeader,
  },
  data() {
    return {
      pageData: null,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      return getMemberExpConfig().then((res) => {
        if (res.code === 200) {
          this.pageData = res.data || {};
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/style/variable.less";
.page-rule {
  height: 100vh;
  min-height: 100%;
  background: #fff;
  overflow-y: auto;
  .rule-wrap{
    word-wrap: break-word;
    font-size: 14px;
    padding: 15px;
  }
}
</style>
